import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const DownloadIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70711 8.29289L11 11.5858V5H13V11.5858L16.2929 8.29289L17.7071 9.70711L12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711L7.70711 8.29289ZM19 17H5V19H19V17Z"
        fill={fillColor || '#48484B'}
      />
    </svg>
  );
};

export { DownloadIcon };
